<template>
    <div id="HeadrContainer">
        <a-row type="flex" justify="space-between">
            <a-col>
                <div @click="goHome" class="container-area">
                    <img src="../assets/image/u9.svg">
                    <div class="item-title">Logistics Operation Center</div>
                </div>
            </a-col>
            <a-col>
                <a-dropdown>
                    <div class="username">
                        <img src="../assets/image/u4.png">
                        <span>Hello: {{userName}}</span>
                        <a-icon type="caret-down" theme="filled" style="margin-left: 8px"/>
                    </div>
                    <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
                        <a-menu-item v-if="!isInnderUser" key="1">
                            <span @click="ChangePassword">
                                <a-icon type="key" class="subMenuItem"></a-icon>
                                <span class="subMenuItem">Change Password</span>
                            </span>
                        </a-menu-item>
                        <a-menu-item key="2">
                            <span @click="handleLogout">
                                <a-icon type="logout"/>
                                <span>Sign Out</span>
                            </span>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>
            </a-col>
        </a-row>
        <ChangePasswordModal v-if="visible"
                             :visible="visible"
                             :modalTitle="'Change Password'"
                             @confirm="confirmPasswordChange"
                             @cancel="cancelPasswordChange">
        </ChangePasswordModal>
    </div>
</template>

<script>
    import {logoOut} from "../utils/requestFail";
    import ChangePasswordModal from './ChangePasswordModal'

    export default {
        name: 'HeadrContainer',
        components: {
            ChangePasswordModal
        },
        data() {
            return {
                userIcon: require('../assets/image/u4.png'),
                userName: '',
                visible: false,
                isInnderUser: false
            }
        },
        destroyed() {
        },
        created() {
            this.setUserInfo()
        },
        methods: {
            setUserInfo() {
                this.userName = this.$store.getters.getUserName
                this.isInnderUser = this.$store.getters.getUserInner === 1
            },
            handleLogout() {
                this.$store.dispatch('removeUserInfo', {})
                this.$store.dispatch('setDefRouters', [])
                // logoOut()
                location.reload()
            },
            ChangePassword() {
                this.visible = true
            },
            goHome() {
                if (this.$router.currentRoute.path === '/') {
                } else {
                    // this.$router.back(99)
                    this.$router.push({
                        path: '/'
                    })
                }
            },
            confirmPasswordChange(res) {
                this.visible = false
                const err = res['errors']
                const war = res['warnings']
                if ((err && err.length > 0) || (war && war.length > 0)) {
                    var msg = err[0] ? err[0] : (war[0] ? war[0] : 'Error')
                    this.$error({
                        title: 'Error',
                        content: msg,
                    });
                } else {
                    this.$success({
                        title: 'Success',
                        content: 'Change Password Success!',
                        okText: 'OK',
                        onOk: () => {
                            this.handleLogout()
                        }
                    })
                }
            },
            cancelPasswordChange() {
                this.visible = false
            }
        },
        computed: {
            newUsername() {
                return this.$store.state.userInfo.userName
            }
        },
        watch: {
            newUsername(newVal, oldVal) {
                if (newVal) {
                   this.userName = newVal
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    #HeadrContainer {
        background-color: #fff;
        padding: 10px;
        padding-top: 20px;
        padding-bottom: 20px;

        .container-area {
            display: flex;
            justify-content: space-around;
            align-items: center;

            .item-title {
                margin-left: 10px;
                font-size: 24px;
                font-weight: 800;
                line-height: 40px;
                height: 40px;
                color: #555555;
                text-rendering: optimizeLegibility;
                font-kerning: normal;
                white-space: nowrap;
                text-transform: none;
            }
        }

        .margion-L-10 {
            margin-left: 10px;
        }

        .username {
            /*background-color: red;*/
            img {
                height: 30px;
                width: 30px;
                margin-right: 10px;
            }

            margin-left: 5px;
            font-size: 16px;
            font-weight: 600;
            height: 40px;
            line-height: 40px;
        }

        .subMenuItem {
            font-size: 20px;
            color: red;
        }
    }

</style>
